{
  "dataSync": {
    "sync": {
      "title": {
        "loading": "Synchronisation",
        "personio": "Synchronisation avec Personio",
        "excel": "Synchronisation avec Excel"
      },
      "steps": {
        "structure": "Structure",
        "newPeople": "Nouvelles personnes",
        "changes": "Modifications",
        "leavers": "Départs",
        "removals": "Suppressions",
        "confirm": "Confirmer"
      },
      "stepsLabel": "Étapes",
      "kind": {
        "departmentCreate": "Nouveau département",
        "departmentMove": "Département déplacé",
        "teamCreate": "Nouvelle équipe",
        "roleCreate": "Nouvelle fonction",
        "systemCreate": "Nouveau système",
        "unitRename": {
          "department": "Département renommé",
          "team": "Équipe renommée",
          "role": "Fonction renommée",
          "system": "Système renommé"
        },
        "unitLead": {
          "department": "Responsable du département",
          "team": "Responsable d'équipe",
          "role": "Responsable de la fonction",
          "system": "Propriétaire du système"
        },
        "unitDelete": {
          "department": "Supprimer le département",
          "team": "Supprimer l'équipe",
          "role": "Supprimer la fonction",
          "system": "Supprimer le système"
        }
      },
      "labelled": "{{label}} : {{value}}",
      "under": "sous {{name}}",
      "topLevel": "Niveau supérieur",
      "field": {
        "name": "Nom",
        "email": "E-mail",
        "department": "Département",
        "role": "Poste",
        "team": "Équipe",
        "location": "Site"
      },
      "skipped": {
        "missingEmail": "Sans e-mail"
      },
      "unsuppliedPeople_one": "{{count}} personne de {{source}} ne peut pas être reprise, car son département, son poste ou son adresse e-mail manque :",
      "unsuppliedPeople_other": "{{count}} personnes de {{source}} ne peuvent pas être reprises, car leur département, leur poste ou leur adresse e-mail manque :",
      "blockedReason": {
        "missingDepartment": "Aucun département",
        "missingRole": "Aucun poste",
        "missingOwner": "Aucun propriétaire du système",
        "nameTaken": "Nom déjà utilisé",
        "emailNotChangeable": "Cette adresse e-mail ne peut pas être modifiée ici",
        "emailTaken": "Adresse e-mail déjà utilisée",
        "externalPerson": "Personne externe",
        "actingAdmin": "Votre propre compte",
        "lastOrgManager": "Dernier responsable d'organisation",
        "inUse": "Encore utilisé",
        "personioLed": "Géré par Personio"
      },
      "waitingOn": "Sélectionnable dès que ses lignes dans ces étapes sont sélectionnées : {{steps}}",
      "leaverReason": {
        "inactive": "inactif dans Personio",
        "absentPersonio": "ne figure plus dans Personio",
        "absentExcel": "ne figure plus dans le fichier"
      },
      "holds": {
        "leads": "Dirige {{name}}",
        "processesOwned_one": "Propriétaire de {{count}} processus",
        "processesOwned_other": "Propriétaire de {{count}} processus",
        "processesAccountable_one": "Responsable de {{count}} processus",
        "processesAccountable_other": "Responsable de {{count}} processus",
        "systemOwned": "Propriétaire du système {{name}}",
        "openAssignments_one": "{{count}} tâche ouverte",
        "openAssignments_other": "{{count}} tâches ouvertes"
      },
      "usage": {
        "people_one": "{{count}} personne",
        "people_other": "{{count}} personnes",
        "subDepartments_one": "{{count}} sous-département",
        "subDepartments_other": "{{count}} sous-départements",
        "orgFunctions_one": "{{count}} équipe ou fonction",
        "orgFunctions_other": "{{count}} équipes ou fonctions",
        "processes_one": "{{count}} processus",
        "processes_other": "{{count}} processus",
        "processSteps_one": "{{count}} étape de processus",
        "processSteps_other": "{{count}} étapes de processus",
        "suggestions_one": "{{count}} suggestion",
        "suggestions_other": "{{count}} suggestions"
      },
      "confirm": {
        "structure": "Créer ou modifier la structure",
        "createPeople": "Créer des personnes",
        "changePeople": "Modifier des personnes",
        "deletePeople": "Supprimer des personnes",
        "deleteUnits": "Supprimer des départements, équipes, fonctions et systèmes",
        "deleteNamedUnits": "Supprimer {{units}}",
        "changeNamedLeads": "Modifier le responsable de {{units}}",
        "noDownloadList": "Ce fichier ne provient pas de « {{button}} ». Bliks ne propose donc ni départs ni suppressions."
      },
      "unitCount": {
        "department_one": "{{count}} département",
        "department_other": "{{count}} départements",
        "team_one": "{{count}} équipe",
        "team_other": "{{count}} équipes",
        "role_one": "{{count}} fonction",
        "role_other": "{{count}} fonctions",
        "system_one": "{{count}} système",
        "system_other": "{{count}} systèmes"
      },
      "apply": "Appliquer la synchronisation",
      "applied": "Synchronisation appliquée",
      "notApplied": "Non appliquée",
      "outcome": {
        "failed": "Échec",
        "conflict": "La valeur a été modifiée dans Bliks depuis la vérification"
      },
      "retry": "Appliquer à nouveau"
    },
    "settings": {
      "title": "Synchronisation des données",
      "kind": {
        "excel": "Excel",
        "personio": "Personio"
      },
      "connections": "Connexions",
      "connected": "Connecté",
      "connect": "Connecter",
      "uploadExcel": "Importer un fichier Excel",
      "downloadExcel": "Télécharger le fichier Excel",
      "startSync": "Lancer la synchronisation",
      "changeCredentials": "Modifier les identifiants",
      "continueSync": "Poursuivre la synchronisation",
      "unlink": "Déconnecter",
      "unlinkConfirm": {
        "title": "Déconnecter Personio ?",
        "description": "Rien n'est supprimé dans Bliks. Vous gérez ensuite les personnes, départements et équipes issus de Personio dans Bliks ou via Excel."
      },
      "lastSync": "Dernière synchronisation : {{date}}",
      "noSyncApplied": "Aucune synchronisation appliquée pour l'instant",
      "invalidRow": "Feuille {{sheet}}, ligne {{row}} : {{errors}}",
      "emptyFile": "La feuille {{sheet}} ne contient aucune personne.",
      "sheetRows_one": "feuille {{sheet}}, ligne {{rows}}",
      "sheetRows_other": "feuille {{sheet}}, lignes {{rows}}",
      "missingSheets": "Il manque des feuilles dans le fichier ({{sheets}}). Veuillez télécharger le fichier actuel et y saisir vos modifications.",
      "missingColumns": "Il manque des colonnes dans certaines feuilles. Veuillez télécharger le fichier actuel et y saisir vos modifications.",
      "sheetColumns": "Feuille {{sheet}} : {{columns}}"
    },
    "personio": {
      "title": "Connecter Personio",
      "replaceTitle": "Modifier les identifiants",
      "clientId": "ID client",
      "clientSecret": "Secret client",
      "test": "Tester la connexion",
      "testSucceeded": "La connexion fonctionne.",
      "connect": "Connecter",
      "instructions": {
        "step1": "Dans Personio, ouvrez <bold>Settings → API credentials</bold> et cliquez sur « Create custom integration » (uniquement avec une offre Personio incluant l’accès API).",
        "step2": "Activez l’accès en lecture pour <bold>Employees</bold> (Bliks y lit aussi les contrats pour le poste) et autorisez ces <bold>Readable employee attributes</bold> : ID, First name, Last name, Email, Status, Department, Team, Position, Supervisor, Workplace. Sans ID, Status, Email, Department et Position, Bliks ne peut reprendre personne.",
        "step3": "Activez l’accès en lecture pour <bold>Org Units</bold> (départements, équipes et leurs responsables).",
        "step3a": "Pour le poste : activez l’accès en lecture pour le <bold>Job catalog</bold>.",
        "step4": "Laissez <bold>Custom Reports</bold> désactivé.",
        "step5": "Saisissez ici l’ID client et le Secret client, puis cliquez sur « Tester la connexion ».",
        "readOnlyNote": "Bliks lit uniquement ces champs et n’écrit jamais rien dans Personio.",
        "helpLink": "Aide Personio : identifiants API (en anglais)",
        "helpUrl": "https://support.personio.de/hc/en-us/articles/4404623630993-Generate-and-manage-API-credentials"
      }
    }
  }
}
